import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "index" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "logo" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"100%","padding":"15px 20px"},
  alt: ""
}, null, -1)

import web_top from '@/components/web_top.vue';
import { useStore } from 'vuex';
import { ref, VueElement, h, reactive, watch, computed } from 'vue';

import { useRoute } from 'vue-router';


import { HomeOutlined, SettingFilled, SettingOutlined, TeamOutlined, ApartmentOutlined } from '@ant-design/icons-vue';



import router from '@/router';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {




const store = useStore();

const route = useRoute();


//监听router 改变切换侧边tab导航栏
watch(() => route, (newRoute) => {
    state.selectedKeys = [newRoute.fullPath];
}, { deep: true })



const collapsed = ref<boolean>(false);
let user = JSON.parse(store.state.user)

console.log(user);






//点击侧边导航栏跳转home子页面
function handleClick(info: any) {
    router.push({ path: info.key })
}


const items = reactive([
    {
        key: '/home',
        icon: () => h(HomeOutlined),
        title: '首页',
        label: '首页',
        disabled: false
    },
    {
        key: '/bankBusiness',
        icon: () => h(ApartmentOutlined),
        title: '转账工作台',
        label: '转账工作台',
        disabled: user.roule === 4 ? true : false
    },
    {
        key: '/rolemanagement',
        icon: () => h(TeamOutlined),
        title: '管理员设置',
        label: '管理员设置',
        disabled: user.roule === 0 ? false : true
    },
    {
        key: '/settings',
        icon: () => h(SettingOutlined),
        title: '设置',
        label: '设置',
        // disabled: user.roule === 0 ? false : true
    }

]);

const state = reactive({
    rootSubmenuKeys: ['/home'],
    openKeys: ['/home'],
    selectedKeys: [router.currentRoute.value.fullPath],
});






const onOpenChange = (openKeys: [string]) => {
    const latestOpenKey = openKeys.find(key => state.openKeys.indexOf(key) === -1);
    if (state.rootSubmenuKeys.indexOf(<string>latestOpenKey) === -1) {
        state.openKeys = openKeys;
    } else {
        state.openKeys = latestOpenKey ? [latestOpenKey] : [];
    }
};







return (_ctx: any,_cache: any) => {
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_layout, { style: {"height":"100vh","overflow":"hidden"} }, {
      default: _withCtx(() => [
        _createVNode(_component_a_layout_sider, {
          collapsed: collapsed.value,
          "onUpdate:collapsed": _cache[1] || (_cache[1] = ($event: any) => ((collapsed).value = $event)),
          collapsible: "",
          theme: "light"
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            _hoisted_3,
            _createVNode(_component_a_menu, {
              selectedKeys: state.selectedKeys,
              "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((state.selectedKeys) = $event)),
              style: {"width":"100%","border":"none"},
              mode: "inline",
              "open-keys": state.openKeys,
              items: items,
              onOpenChange: onOpenChange,
              theme: "light",
              onClick: handleClick
            }, null, 8, ["selectedKeys", "open-keys", "items"])
          ]),
          _: 1
        }, 8, ["collapsed"]),
        _createVNode(_component_a_layout, { style: {"border-left":"1px solid #f0f0f0"} }, {
          default: _withCtx(() => [
            _createVNode(_component_a_layout_header, { style: {"padding":"0","height":"60px"} }, {
              default: _withCtx(() => [
                _createVNode(web_top)
              ]),
              _: 1
            }),
            _createVNode(_component_a_layout_content, { class: "app_content" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_spin, {
                  class: "loading",
                  spinning: _unref(store).state.spinning,
                  tip: "Loading..."
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_view)
                  ]),
                  _: 1
                }, 8, ["spinning"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})